/* unplugin-vue-components disabled */import { render } from "./officialSite.vue?vue&type=template&id=3d6a813d&scoped=true"
import script from "./officialSite.vue?vue&type=script&lang=js"
export * from "./officialSite.vue?vue&type=script&lang=js"

import "./officialSite.vue?vue&type=style&index=0&id=3d6a813d&lang=sass&scoped=true"

import exportComponent from "/app/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6a813d"]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge});
